import { useCallback, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../Components/InboxDashboard/Inbox.css";
import "../Components/InboxDashboard/InboxHistory.css";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import { fetchInboxTabCount } from "../Providers/main";
import {
  setSelectedPanelId,
  setSelectedPanelName,
  setTabsToShow,
  setUnsortedCase,
  setUnsortedPage,
  setInboxTabsCount,
  setInboxRefreshDocuments,
  setInboxRefreshDocumentsDueToDelete,
} from "../Redux/inbox/actions";
import Footer from "../Components/common/footer";
import InboxDashboard from "../Components/InboxDashboard/NewInboxDashboard/InboxDashboard";
import InboxActionBar from "../Components/InboxDashboard/inboxActionBar";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";
import useInboxDocuments from "../Hooks/useInboxDocuments";
import useInboxWebSocket from "../Hooks/useInboxWebSocket";

const InboxPage = () => {
  const dispatch = useDispatch();
  const inboxTab = useSelector((state) => state.inbox.inboxTab);
  const inboxRefreshDocuments = useSelector((state) => state.inbox.inboxRefreshDocuments);
  const inboxRefreshDocumentsDueToDelete = useSelector(
    (state) => state.inbox.inboxRefreshDocumentsDueToDelete
  );
  const inboxSearch = useSelector((state) => state.inbox.inboxSearch);
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  const {
    pageNumber,
    totalPages,
    pagination,
    loading,
    setPageNumber,
    refreshCurrentPage,
    resetAndRefresh,
  } = useInboxDocuments({ tabName: inboxTab, searchKey: inboxSearch });

  const refreshTabCounts = useCallback(
    () => fetchInboxTabCount(dispatch, setInboxTabsCount),
    [dispatch]
  );

  const handleInboxChanged = useCallback(() => {
    resetAndRefresh();
    refreshTabCounts();
  }, [refreshTabCounts, resetAndRefresh]);

  useInboxWebSocket({
    activeTab: inboxTab,
    refreshTabCounts,
    refreshCurrentPage,
    resetAndRefresh,
  });

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 28).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    fetchShakespeareStatus(caseId, 28, dispatch);
  }, [caseId, dispatch]);

  useEffect(() => {
    dispatch(setTabsToShow({}));
    dispatch(setSelectedPanelId("-1"));
    dispatch(setSelectedPanelName());
    dispatch(setUnsortedCase(true));
    dispatch(setUnsortedPage(true));

    refreshTabCounts();
  }, [dispatch, inboxSearch, inboxTab, refreshTabCounts]);

  useEffect(() => {
    if (!inboxRefreshDocuments && !inboxRefreshDocumentsDueToDelete) return;

    handleInboxChanged();

    if (inboxRefreshDocuments) dispatch(setInboxRefreshDocuments(false));
    if (inboxRefreshDocumentsDueToDelete) {
      dispatch(setInboxRefreshDocumentsDueToDelete(false));
    }
  }, [dispatch, handleInboxChanged, inboxRefreshDocuments, inboxRefreshDocumentsDueToDelete]);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container">
          <NavBar flaggedPageName="28" />
          <InboxActionBar pageObj={pageObject} />
          <InboxDashboard
            pageNumber={pageNumber}
            totalPages={totalPages}
            pagination={pagination}
            paginationLoading={loading}
            setPageNumber={setPageNumber}
            onInboxChanged={handleInboxChanged}
          />
        </div>
      </div>
      <Footer />
      {/* </div> */}
    </>
  );
};

export default InboxPage;
